export const messageCharacterSizeLimit = 10_000
export const messageTranscriptSizeLimit = 150
